// Constants for Select
export const VIRTUALIZED_DROPDOWN_MAX_HEIGHT = 288;
export const VIRTUALIZED_DROPDOWN_MIN_ROW_HEIGHT = 40;
export const VIRTUALIZED_DROPDOWN_OVERSCAN = 6;

// Constants for Multiselect
export const VIRTUALIZED_MENU_MAX_HEIGHT = 200;
export const VIRTUALIZED_MENU_MIN_ROW_HEIGHT = 40;
export const VIRTUALIZED_MENU_OVERSCAN = 6;

// Constants for DynamicFieldTable
export const DEFAULT_VIRTUALIZED_ROW_HEIGHT = 80;
export const DEFAULT_VIRTUALIZED_BODY_HEIGHT = 420;
export const DEFAULT_VIRTUALIZED_OVERSCAN = 6;
